import { userConstants } from './../constants/user.constants';

const initialState = {};

export function callingBankdetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.CALLINGBANKDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CALLINGBANKDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CALLINGBANKDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}